// extracted by mini-css-extract-plugin
export default {"itemContainer":"productdetails_itemContainer__io+Ns","image":"productdetails_image__Zpf4Z","productContainer":"productdetails_productContainer__LnFBg"};